export default "__VITE_ASSET__LOkMaHib__"